import React from 'react'
import PublicRoute from '../components/RouteVisibility/PublicRoute/PublicRoute'
import ManVsMachineCheckoutContainer from '../pages/ManVsMachineCheckout'
import ManVsMachineRegistrationPage from '../pages/ManVsMachineCheckout/ManVsMachineRegistrationPage'

export const MAN_VS_MACHINE_CHECKOUT_PATH = '/man_vs_machine_checkout'
export const MAN_VS_MACHINE_REGISTRATION_PATH = '/man_vs_machine_registration'

export const MAN_VS_MACHINE_CHECKOUT_ROUTES = [
	{
		path: MAN_VS_MACHINE_CHECKOUT_PATH,
		element: <PublicRoute />,
		children: [
			{
				path: '',
				element: <ManVsMachineCheckoutContainer />,
			},
		],
	},
	{
		path: MAN_VS_MACHINE_REGISTRATION_PATH,
		element: <PublicRoute />,
		children: [
			{
				path: '',
				element: <ManVsMachineRegistrationPage />,
			},
		],
	},
]
